import { render, staticRenderFns } from "./Visios.vue?vue&type=template&id=d5c24d22"
import script from "./Visios.vue?vue&type=script&lang=js"
export * from "./Visios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports